import currencies from '@/assets/data/dashboard-currency.json'

export const DEFAULT_CURRENCY_SYMBOL = '€'

// Used when the active countries list hasn't been loaded yet
const TAG_ALPHA_3_CODES = {
  spain: 'esp',
  romania: 'rou',
  poland: 'pol',
}

export const getCurrencySymbol = (activeCountries = []) => {
  const tag = localStorage.getItem('connection') || 'spain'
  const country = (activeCountries || []).find((item) => item.tag === tag)
  const alpha3 = (
    country?.alpha_3_code ||
    TAG_ALPHA_3_CODES[tag] ||
    'esp'
  ).toLowerCase()

  return (
    country?.dashboard_currency_symbol ||
    currencies[alpha3] ||
    DEFAULT_CURRENCY_SYMBOL
  )
}
